import React from 'react'
import Slider from 'rc-slider'

const playerProgress = ({
    progressHandler,
    progressValue,
}) => (
        <div className="player-progress">
            <Slider
                railStyle={{ background: "#ECF0F1", boderRadius: 10 }}
                trackStyle={{ background: "#00B2FF" }}
                handleStyle={{ background: "#00B2FF", border: "#00B2FF" }}
                volume={50}
                max={1000}
                onChange={value => progressHandler(value / 1000)}
                value={progressValue}
            />
        </div>
    )

export default playerProgress
